import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, text3XL, text5XL, textLG, textSM } from '@styles/fonts'
import styled from 'styled-components'

export const SubTitle = styled.div`
  ${text5XL};
  color: ${COLORS.nature.base};
  margin: 0;
  line-height: 62px;
  letter-spacing: 20px;

  @media ${DEVICES.mobile} {
    ${text3XL};
    letter-spacing: 8px;
    line-height: 44px;
  }

  h1,
  span {
    ${text5XL};
    font-family: ${FONTS.bold};
    text-transform: uppercase;
    color: ${COLORS.nature.base};
    margin: 0;
    line-height: 62px;
    letter-spacing: 20px;

    @media ${DEVICES.mobile} {
      ${text3XL};
      letter-spacing: 8px;
      line-height: 44px;
    }
  }
`

export const Title = styled.span`
  ${textLG};
  letter-spacing: 2px;
  text-transform: capitalize;
  font-family: ${FONTS.medium};
  color: ${COLORS.nature.base};
`

export const H1 = styled.h1`
  ${textSM};
  font-family: ${FONTS.medium};
  margin: -16px 0 0;
  letter-spacing: 5px;
`

export const SuburbProfileHero = styled.section`
  min-height: 100dvh;
  background-color: ${COLORS.navi};
  color: ${COLORS.nature.base};
  text-align: center;
  padding-top: 90px;
  display: flex;
  flex-direction: column;
  background-size: cover;
  position: relative;

  &::after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    width: 100%;
    height: 100%;
  }

  .breadcrumbs {
    margin: 0 auto;
    display: inline-flex;
    position: relative;
    z-index: 5;

    a,
    span {
      color: ${COLORS.nature.base};
    }

    span {
      text-decoration: underline;
    }
  }

  @media ${DEVICES.mobile} {
    padding-top: 62px;
  }
`

export const SuburbProfileHeroInner = styled.div`
  margin: 0px 42px;
  border-top: 1px solid ${COLORS.nature[95]};
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  z-index: 5;

  @media ${DEVICES.mobile} {
    margin: 0px 16px;

    .breadcrumbs {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      row-gap: 4px;
    }
  }
`

export const SuburbProfileHeroContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 44px;
`

export const SuburbProfileHeroActions = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`
